import { Endpoint } from '../endpoint';
import { GraphResponse, GraphNoteResponse } from '@business/entities/graph';
import { GraphNoteFormData } from '@modules/statistics/graphs/EditGraphNoteModal/EditGraphNoteModal';

export function createNote(data: GraphNoteFormData) {
  return Endpoint.post<GraphResponse>(`@makh/graph-notes`, { data });
}

export function updateNote(id: string, data: GraphNoteFormData) {
  return Endpoint.patch<GraphResponse>(`@makh/graph-notes/${id}`, { data });
}

export function fetchNote(id: string) {
  return Endpoint.get<GraphNoteResponse>(`@makh/graph-notes/value/${id}`);
}

export function deleteNote(id: string) {
  return Endpoint.delete<GraphResponse>(`@makh/graph-notes/${id}`);
}
